import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal } from "@/components/site/Reveal";
import { CHAPTERS, IMAGES } from "@/data/content";

export const Process = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative border-t border-white/10 bg-[#0d0d0c]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-24 sm:py-32 grid grid-cols-1 lg:grid-cols-12 gap-16">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-[#C05C3F]">
              / The process
            </span>
            <h2 className="mt-5 font-serif text-4xl sm:text-5xl font-light tracking-tight text-[#F4F3F0] leading-[0.95]">
              A build without <span className="italic">surprises.</span>
            </h2>
            <div className="mt-10 relative overflow-hidden border border-white/10 h-[320px]">
              <motion.img
                style={{ y }}
                src={IMAGES.craftWide}
                alt="Craftsman at work"
                className="absolute inset-0 h-[130%] w-full object-cover grayscale"
              />
              <div className="absolute inset-0 bg-[#111110]/30" />
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.05}>
              <div
                data-testid={`chapter-${c.num}`}
                className="grid grid-cols-[auto_1fr] gap-8 py-10 border-b border-white/10 last:border-b-0"
              >
                <span className="font-mono text-5xl sm:text-6xl font-bold text-[#C05C3F]/25 leading-none">
                  {c.num}
                </span>
                <div>
                  <h3 className="font-serif text-3xl sm:text-4xl font-light text-[#F4F3F0] mb-3">
                    {c.title}
                  </h3>
                  <p className="text-base text-[#F4F3F0]/70 font-light leading-relaxed max-w-lg">
                    {c.body}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
